import { Component, EventEmitter, inject, Input, Output } from "@angular/core";
import { environment } from "src/environments/environment";
import { PipesModule } from "../../../../../utils/pipes/pipes.module";
import { SharedModule } from "src/shared/shared.module";
import { Router } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { CommonModule } from "@angular/common";
import { ToastService } from "src/app/services/toast-service/toast.service";
import { SweetAlertService } from "src/app/services/sweet-alert-service/sweet-alert.service";
import { ActiveStudentCourseComponent } from "./_dialogs/active-student-course/active-student-course.component";
import { TranslateModule, TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-student-course-item",
  imports: [
    PipesModule,
    SharedModule,
    MatProgressBarModule,
    NgbTooltipModule,
    CommonModule,
    TranslateModule,
  ],
  templateUrl: "./student-course-item.component.html",
  styleUrl: "./student-course-item.component.scss",
})
export class StudentCourseItemComponent {
  @Input() course: any;
  @Output() activateCourseEvent = new EventEmitter<any>();

  #router = inject(Router);
  #toastService = inject(ToastService);
  #swalService = inject(SweetAlertService);
  #translate = inject(TranslateService);

  private dialog = inject(MatDialog);
  fileUrl = environment.apiFileUrl;
  item: any;

  onRoute(): void {
    if (this.course.is_expire) {
      this.#toastService.toastError(
        this.#translate.instant("ONLINE_CLASS.COURSE_TIMEOUT")
      );
    } else {
      this.#router.navigate([`online-class/${this.course.id}/watch`], {});
    }
  }

  async onActivate(): Promise<void> {
    // await this.#swalService.swalConfirmation();
    const dialogRef = this.dialog.open(ActiveStudentCourseComponent, {
      data: { course: this.course },
      height: "auto",
      width: "400px",
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.activateCourseEvent.emit(true);
      }
    });
  }
}
